import { NgModule } from '@angular/core';
import { SearchHighlightPipe } from './search-highlight.pipe';

@NgModule({
  exports: [SearchHighlightPipe],
  declarations: [SearchHighlightPipe],
})
export class SearchHighlightModule {}
